<template>
  <WebsiteLayout>
    <div class="app-container hero">
      <div class="main-app-wrapper dashboard">
        <div class="professional-profile">
          <div class="div-block-110">
            <div @click="goToBack" class="link-block-12 w-inline-block">
              <img
                src="@/assets/timeslot-images/arrow-left.svg"
                loading="lazy"
                alt=""
                class="image-24"
              />
              <div class="text-block-89">Back</div>
            </div>
          </div>
          <div class="profile-wrapper-customer">
            <div class="div-block-61"></div>
            <div class="div-block-62-copy">
              <div class="div-block-63">
                <div class="image-wrapper">
                  <div class="image-wrap-head">
                    <img
                      :src="
                        customerInfo.customerDisplayPicture ||
                          require('@/assets/timeslot-images/profileImg.svg')
                      "
                      loading="lazy"
                      width="100%"
                      height="100%"
                      alt=""
                      class="image-15"
                    />
                  </div>
                </div>
                <div class="div-block-64">
                  <div class="text-block-53">
                    {{ customerInfo.customerName }}
                  </div>
                  <div class="text-block-54">
                    {{ customerInfo.customerInterest }}
                  </div>
                </div>
              </div>
              <div
                class="div-block-65"
                v-if="this.$route.params.id === userInfo.customerId"
              >
                <router-link
                  to="/customer-settings"
                  class="button edit w-button"
                  >Edit profile</router-link
                >
                <!--                <a-->
                <!--                  data-w-id="da40a350-1864-32e5-9f2d-e40a29b21b5d"-->
                <!--                  href="#"-->
                <!--                  class="button outline w-button"-->
                <!--                  @click="openConnect"-->
                <!--                  >View connections</a-->
                <!--                >-->
              </div>
            </div>
          </div>
          <div class="profile-details">
            <div
              data-current="Tab 1"
              data-easing="ease"
              data-duration-in="300"
              data-duration-out="100"
              class="w-tabs"
            >
              <div class="tabs-menu-3 w-tab-menu">
                <a
                  data-w-tab="Tab 1"
                  class="booking-tab w-inline-block w-tab-link w--current"
                >
                  <div>Overview</div>
                </a>
              </div>
              <div class="w-tab-content">
                <div data-w-tab="Tab 1" class="w-tab-pane w--tab-active">
                  <div class="div-block-66">
                    <div class="about-professional-wrapper">
                      <div>
                        <div class="text-block-55">About</div>
                        <p class="paragraph-5">
                          {{ customerInfo.customerAbout }}
                        </p>
                        <!--                        <a href="" class="link-block-6 w-inline-block"-->
                        <!--                          ><img-->
                        <!--                            loading="lazy"-->
                        <!--                            src="@/assets/timeslot-images/linkedin-1.svg"-->
                        <!--                            alt=""-->
                        <!--                        /></a>-->
                      </div>
                      <div class="div-block-68">
                        <div class="text-block-55">Location</div>
                        <p class="paragraph-5">
                          {{ customerInfo.customerCountry }}
                        </p>
                      </div>
                      <!--                      <div class="div-block-68">-->
                      <!--                        <div class="text-block-55">Role</div>-->
                      <!--                        <p class="paragraph-5-copy">-->
                      <!--                          {{ userInfo.professional.professionalSubCategory }}-->
                      <!--                        </p>-->
                      <!--                      </div>-->
                      <!--                      <div class="div-block-68">-->
                      <!--                        <div class="text-block-55">Industry</div>-->
                      <!--                        <p class="paragraph-5-copy">-->
                      <!--                          {{ userInfo.professional.professionalCategory }}-->
                      <!--                        </p>-->
                      <!--                      </div>-->
                      <!--                      <div class="div-block-68">-->
                      <!--                        <div class="text-block-55">Experience Level</div>-->
                      <!--                        <p class="paragraph-5-copy">-->
                      <!--                          {{-->
                      <!--                            userInfo.professional.professionalExperienceLevel-->
                      <!--                          }}-->
                      <!--                        </p>-->
                      <!--                      </div>-->
                    </div>
                    <div
                      class="become-a-professional--profile"
                      v-if="userInfo.userRole.toLowerCase() === 'customer'"
                    >
                      <div class="profile-become-a-pro">
                        <img
                          src="@/assets/timeslot-images/Group-36721.png"
                          loading="lazy"
                          width="108"
                          alt=""
                          class="image-3"
                        />
                        <div class="text-block-9">Become a Professional</div>
                        <div class="text-block-10">
                          Based on your expertise, we feel you may be interested
                          in these professionals
                        </div>
                        <router-link
                          data-w-id="3d27f69f-192e-9d97-47ef-c00991f55c34"
                          to="/become-a-professional"
                          class="timeslot-button w-button"
                          >Get started</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ViewConnectionsModal v-if="connect" :cancel="closeConnect" />
  </WebsiteLayout>
</template>

<script>
import WebsiteLayout from "@/components/layout/WebsiteLayout";
import ViewConnectionsModal from "@/components/modal/ViewConnectionsModal";
import { mapState } from "vuex";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import CustomerRequest from "@/model/requests/CustomerRequest";

export default {
  name: "CustomerProfile",
  components: { WebsiteLayout, ViewConnectionsModal },
  data() {
    return {
      connect: false,
      readModel: CustomerRequest.readBy
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      customerInfo: state => state.customer.customerInfo,
      imageUrl: state => state.customer.imageUrl
    })
  },
  methods: {
    openConnect() {
      this.connect = true;
    },
    closeConnect() {
      this.connect = false;
    },
    goToBack() {
      RouterUtils.goBackOnce();
    }
  },
  mounted() {
    let customerId = this.$route.params.id;
    this.readModel.customerId = customerId;
    StoreUtils.dispatch(
      StoreUtils.actions.customer.READ_BY_CUSTOMER,
      this.readModel
    );
  }
};
</script>

<style scoped>
.image-wrapper {
  display: flex;
  height: 5.625rem;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
}

.image-wrap-head {
  width: 8.75rem;
  height: 8.75rem;
  flex: 0 0 8.75rem;
  position: relative;
  border-radius: 50%;
  margin-top: -3.125rem;
  border: 5px solid rgb(255, 255, 255);
  background-color: #f1f2f4;
}
</style>
